import { Controller, useForm } from "react-hook-form";
import { Dialog } from "components/Dialog";
import { Button } from "components/Button";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import { TCity, TProvince } from "types/dto";

type TProps = {
  record?: TCity;
  isOpen?: boolean;
  onClose: () => void;
  onSubmit: (value: TEditFormTypes) => void;
  province: TProvince;
  isLoading: boolean;
};

export type TEditFormTypes = {
  name: string;
};

export function EditCityModal(props: TProps) {
  const {
    isOpen = false,
    onClose,
    onSubmit,
    province,
    isLoading,
    record,
  } = props;

  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<TEditFormTypes>({
    defaultValues: {
      name: record?.name,
    },
  });

  return (
    <Dialog
      maxWidth={false}
      dialogTitle={t("editCity")}
      open={isOpen}
      onClose={onClose}
      canClose={!isLoading}
    >
      <form className="p-4 w-[640px]" onSubmit={handleSubmit(onSubmit)}>
        <div className={"flex"}>
          <p>{t("editCity")}</p>
          <p className={"text-primary-60 font-bold mr-1"}>{record?.name}</p>
          <p className={"mr-1"}>{t("forProvince")}</p>
          <p className={"text-primary-60 font-bold mr-1"}>{province?.name}</p>
        </div>
        <div className="flex w-1/2 mt-4">
          <Controller
            name={"name"}
            control={control}
            rules={{
              required: "الزامی است",
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  label={t("cityName")}
                  placeholder={t("cityName")}
                  size="small"
                  {...field}
                  error={Boolean(error)}
                  className={"w-full"}
                />
              );
            }}
          />
        </div>
        <div className="col-span-12 flex items-center justify-end mt-3">
          <Button
            className="w-20"
            loading={isLoading}
            type="submit"
            variant="contained"
          >
            {t("edit")}
          </Button>
        </div>
      </form>
    </Dialog>
  );
}
